import { SidebarInset, SidebarProvider } from '@talentmesh/ui/components/sidebar';
import { TooltipProvider } from '@talentmesh/ui/components/tooltip';
import React from 'react';
import NavDrawer from './NavDrawer';
import Page from '@/Components/page';

// https://ui.shadcn.com/docs/components/radix/sidebar#width
const NAV_SIDEBAR_WIDTH_REM = '13.75rem';

interface CandidatesPageLayoutProps {
    sidebar?: React.ReactNode;
}

const CandidatesPageLayout = ({ sidebar, children }: React.PropsWithChildren<CandidatesPageLayoutProps>) => {
    return (
        <Page className="bg-muted">
            <SidebarProvider
                className="flex min-h-0 w-full flex-1 flex-row overflow-hidden"
                defaultOpen
                style={
                    {
                        '--sidebar-width': NAV_SIDEBAR_WIDTH_REM,
                    } as React.CSSProperties
                }
            >
                <TooltipProvider>
                    <NavDrawer>{sidebar}</NavDrawer>
                    <SidebarInset className="flex flex-1 flex-col overflow-hidden bg-transparent">
                        <div className="flex flex-1 flex-col overflow-auto">{children}</div>
                    </SidebarInset>
                </TooltipProvider>
            </SidebarProvider>
        </Page>
    );
};

export default CandidatesPageLayout;
